/**
 * Transient confirmation shown right after a successful sign-in — phone OTP,
 * email magic-link, and the in-page slide-over on /find all land the visitor
 * straight on Home (or back on /find) with zero feedback that anything just
 * happened. This closes that gap: a brief "Successfully signed in" banner,
 * auto-dismissed by the parent after a few seconds (see App.tsx's
 * `justSignedIn` timer) — no close button, since it's non-blocking and short-
 * lived by design.
 *
 * Rendered in-flow at the top of the content column (not a fixed overlay):
 * the header's height varies by route (the signed-in Home adds an Ask-Avery
 * row), so floating this over the header risked clipping it on some routes.
 */
export function SignedInToast() {
  return (
    // Outer flex row centers the pill within the content column; the pill
    // itself is inline-flex so it hugs its content width instead of a
    // block-level flex container's default of stretching to fill (which
    // wrapped the text onto two lines).
    <div style={{ display: 'flex', justifyContent: 'center', marginBottom: 16 }}>
      <div
        role="status"
        className="fadein"
        style={{
          display: 'inline-flex',
          alignItems: 'center',
          gap: 10,
          whiteSpace: 'nowrap',
          background: 'var(--color-white)',
          boxShadow: 'var(--shadow-md)',
          borderRadius: 'var(--radius-full)',
          padding: '10px 18px 10px 12px',
        }}
      >
        <span
          aria-hidden="true"
          style={{
            width: 22, height: 22, borderRadius: '50%', flexShrink: 0,
            background: 'var(--color-success-bg)',
            display: 'inline-flex', alignItems: 'center', justifyContent: 'center',
          }}
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="var(--color-success)"
            strokeWidth="3.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            <path d="M20 6L9 17l-5-5" />
          </svg>
        </span>
        <span style={{ fontSize: 13.5, fontWeight: 700, color: 'var(--color-black)' }}>
          Successfully signed in
        </span>
      </div>
    </div>
  )
}
